import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import {
  useForm,
  FormProvider,
  Controller
} from 'react-hook-form';
import { Btnone } from '../../basic/button';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { postReviews } from '../../../../redux/slices/reviews';
import StarRatingInput from './StarRatingInput';
import CommentInput from './CommentInput';

const SubmitReviewsfrom = ({ id, setIsOpen }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);

  const schema = Yup.object().shape({
    rating: Yup.number()
      .required('Rating is required')
      .min(1)
      .max(5),
    comment: Yup.string()
      .required('Comment is required')
      .min(10, 'Comment must be at least 10 characters'),
    images: Yup.mixed()
  });

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      rating: '',
      comment: '',
      images: []
    }
  });

  const {
    register,
    reset,
    handleSubmit,
    formState: { isSubmitting }
  } = methods;

  const onSubmit = async (data) => {
    if (loading) return;
    setLoading(true);

    try {
      const userData = localStorage.getItem("user");
      const parsedUser = userData ? JSON.parse(userData) : null;

      if (!parsedUser?.id || !parsedUser?.email || !parsedUser?.name) {
        toast.error("User information is missing. Please log in again.");
        return;
      }

      const formData = new FormData();
      formData.append("product_id", id);
      formData.append("user_id", parsedUser.id);
      formData.append("username", parsedUser.name);
      formData.append("email", parsedUser.email);
      formData.append("rating", parseInt(data.rating));
      formData.append("comment", data.comment);

      // Append multiple images
      if (selectedImages.length > 0) {
        selectedImages.forEach((img) => {
          formData.append("images[]", img);
        });
      }

      dispatch(postReviews(formData, toast, reset, setIsOpen));
    } catch (error) {
      console.error("Submit Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const isLoggedIn = Boolean(localStorage.getItem("accessToken"));

  if (!isLoggedIn) {
    return (
      <div className="bg-yellow-50 border border-yellow-300 p-4 rounded-md">
        <p className="text-yellow-800 mb-3 font-medium">
          You must be logged in to submit a review.
        </p>
        <button
          onClick={() => navigate("/login")}
          className="bg-[#00A762] text-white px-4 py-2 rounded-md hover:bg-green-700 transition"
        >
          Login to Submit Review
        </button>
      </div>
    );
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
        <StarRatingInput />
        <CommentInput />

        {/* Image Upload */}
        <div>
          <label className="block text-[#072320] font-dm text-lg capitalize font-medium mb-2">
            Upload Images
          </label>
          <input
            type="file"
            accept="image/*"
            multiple
            {...register("images")}
            onChange={(e) => setSelectedImages(Array.from(e.target.files))}
            className="block w-full border rounded-md p-2"
          />
          {selectedImages.length > 0 && (
            <div className="mt-2 flex gap-2 flex-wrap">
              {selectedImages.map((img, index) => (
                <img
                  key={index}
                  src={URL.createObjectURL(img)}
                  alt="preview"
                  className="w-16 h-16 object-cover rounded-md border"
                />
              ))}
            </div>
          )}
        </div>

        <div className="pt-4">
          <Btnone
            title={loading ? "Submitting..." : "Submit"}
            bgColor="#00A762"
            type="submit"
            disabled={loading || isSubmitting}
          />
        </div>
      </form>
    </FormProvider>
  );
};

export default SubmitReviewsfrom;
